import { render, staticRenderFns } from "./ChangeQuestionView.vue?vue&type=template&id=eff6aeaa&scoped=true"
import script from "./ChangeQuestionView.vue?vue&type=script&lang=js"
export * from "./ChangeQuestionView.vue?vue&type=script&lang=js"
import style0 from "./ChangeQuestionView.vue?vue&type=style&index=0&id=eff6aeaa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff6aeaa",
  null
  
)

export default component.exports